import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireHeader } from "/Users/yvonne/Repositories/1. Green Dev/shopify-greendev-theme/dev/js/header.js";
var headerExports = requireHeader();
export { headerExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(headerExports);